import { useState } from "react";

import { SearchInput } from "@components/Input";
import { AddressSuggestionList } from "@components/List";
import { OnboardingLayoutProps } from "@components/OnboardingLayout";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { EntryStepLayout as OnboardingLayout } from "@entry/EntryStepLayout";
import { useAddressSuggestion } from "@hooks";
import { Translations, i18n } from "@i18n";

export const EmployerAddressRoute = () => {
  const [input, setInput] = useState("");

  const { data } = useAddressSuggestion({ input });

  const props: OnboardingLayoutProps = {
    title: i18n.t(Translations.EmployerAddressRouteTitle),
    subContent: <AddressSuggestionList data={data} flow="employer" />,
  };

  return (
    <OnboardingLayout {...props}>
      <SearchInput
        label={i18n.t(Translations.EmployerAddressRouteInputLabel)}
        placeholder={i18n.t(Translations.EmployerAddressRouteInputPlaceholder)}
        value={input}
        setValue={setInput}
      />
      <Spacing size={SpacingSizes.M} />
    </OnboardingLayout>
  );
};
